const API_URL = 'https://sub.ouvg.top/api';

export async function checkSubscription(email) {
  try {
    const response = await fetch(`${API_URL}/check-subscription`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error('网络响应不正常');
    }

    return response.json();
  } catch (error) {
    console.error('Error checking subscription:', error);
    throw error;
  }
}

